module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools",
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [(_vm.$onduro.hasRole('planner') && _vm.initialized) ? _c('div', {
    staticClass: "tools-tabs"
  }, [_vm._l((_vm.tabs), function(tab) {
    return (tab.show) ? _c('a', {
      class: [(tab.name === _vm.activeTab) ? 'is-active' : '', tab.class ? tab.class : ''],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleActive(tab.name)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": tab.icon
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.showTrash) ? _c('a', {
    class: ['tools-close', 'is-trash', _vm.visible > 7 ? 'has-shadow' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.trash.apply(null, arguments)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "delete"
    }
  })], 1) : _c('a', {
    class: ['tools-close', _vm.visible > 7 ? 'has-shadow' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasRole('planner')) ? _c('tab-' + _vm.activeTab, {
    tag: "component",
    attrs: {
      "item": _vm.payload,
      "date": _vm.payload
    }
  }) : _c('employee', {
    attrs: {
      "item": _vm.payload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78eb82e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Tools.vue
// module id = 615
// module chunks = 234